"use client"

import React from "react";
import { useTranslations } from "next-intl";
import cn from "classnames";
import {
    Flex,
    Spin
} from "antd";
import dayjs from "dayjs";
import dynamic from "next/dynamic";
import utc from 'dayjs/plugin/utc';
import style from "./purchasedConnections.module.scss";
import {
    Card,
} from "@/theme/ui";
import {
    useApi,
    useTempData
} from "@/lib/hook";
import { PopoverDatePreset } from "@/theme/ui/datePicker/customPicker";

dayjs.extend(utc);

const Column = dynamic(() => import('@ant-design/plots').then(({ Column }) => Column),
    { ssr: false }
);

const initFilterData = {
    start: dayjs().utc().locale('uk').startOf('week').toDate(),
    end: dayjs().utc().locale('uk').endOf('week').toDate(),
    key: 'week'
}

export const PurchasedConnections = () => {
    const t = useTranslations('reports.connections');
    const {data: tempData, setTempData} = useTempData('purchased_connection', initFilterData);
    const { data: data, isFetching } = useApi({
        route: {
            name: 'reports.connections',
        },
        data: {...tempData},
        setting: {
            select: (resp) => resp,
        },
    });

    const changeDate = (value, key) => {
        setTempData({
            start: value.start,
            end: value.end,
            key: key
        })
    }

    const config = {
        data: data ?? [],
        xField: 'date',
        yField: 'connections',
        stack: true,
        colorField: 'type',
        scale: { color: { range: ['#9E3636', '#D7CBCB', '#DD8080'] } },
        height: 365,
    };

    return (
        <>
            <div className={cn(style.block, 'support_block')}>
                <Card
                    className={'charts'}
                >
                    <Spin spinning={isFetching}>
                        <Flex
                            justify={'space-between'}
                            align={'center'}
                            wrap={'wrap'}
                            gap={10}
                        >
                            <div
                                className={style.title}
                            >
                                {t('title')}
                            </div>
                            <PopoverDatePreset
                                onChange={changeDate}
                                initData={initFilterData.key}
                                date={tempData}
                            />
                        </Flex>
                        {!isFetching && data?.length > 0 ? (
                            <Column {...config} />
                        ) : (
                            <div style={{ textAlign: 'center', paddingTop: 100 }}>{t('no_data')}</div>
                        )}
                    </Spin>
                </Card>
            </div>
        </>
    );
}